enum NotificationTypes {
    Success,
    Error,
    Warning,
    Info,
}

export default NotificationTypes;
